import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  ADD_PAYMENT_MODE,
  GET_ALL_PAYMENT_MODE_DATA,
} from "../../../services/apiUrls";
import { get, post, Put } from "../../../services/service";
import EditIcon from "@mui/icons-material/Edit";
import toast from "react-hot-toast";
import axios from "axios";

export function usePaymentMode() {
  const [open, setOpen] = useState(false);

  const [formValue, setFormValue] = useState({ id: "", paymentMode: "" });

  const [paymentMode, setPaymentMode] = useState([]);

  const [search, setSearch] = useState("");

  // const locationId = localStorage.getItem("locationId");
  // const tenantId = localStorage.getItem("tenantId");

  const columns = [
    {
      field: "No.",
      headerName: "NO.",
      width: 65,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "paymentMode",
      headerName: "PAYMENT MODE",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    // {
    //   field: "deleted",
    //   headerName: "STATUS",
    //   flex: 1,
    //   headerClassName: "super-app-theme--header",
    //   renderCell: (params) => {
    //     return (
    //       <Box>
    //         <Button
    //           onClick={() => {
    //             statusInactive(params?.row?.id);
    //           }}
    //         >
    //           {params?.row?.deleted === false ? (
    //             <Button
    //               variant="contained"
    //               size="small"
    //               color="success"
    //               sx={{ width: "2rem" }}
    //             >
    //               <Typography sx={{ fontSize: "10px" }}>Active</Typography>
    //             </Button>
    //           ) : (
    //             <Button
    //               variant="contained"
    //               size="small"
    //               color="error"
    //               sx={{ width: "2rem" }}
    //             >
    //               <Typography sx={{ fontSize: "10px" }}>Inactive</Typography>
    //             </Button>
    //           )}
    //         </Button>
    //       </Box>
    //     );
    //   },
    // },
    {
      field: "action",
      headerName: "ACTION",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <EditIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setOpen(true);
              window.scrollTo(0, 0);
              // getPaymentModeById(params.id);
              console.log(params.row);
              setFormValue({ ...params.row });
            }}
          />
        );
      },
    },
  ];

  const handleInputChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const paymentModeFilterData = paymentMode.filter((item) =>
    item.paymentMode.toLowerCase().includes(search.toLowerCase())
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    handleClear();
  };

  const handleClear = () => {
    setFormValue({ id: "", paymentMode: "" });
  };

  const isDisabled = formValue?.paymentMode !== "";

  const getAllPaymentModeMasterData = async () => {
    const resp = await get(GET_ALL_PAYMENT_MODE_DATA);
    if (resp && resp?.[0]?.id !== " ") {
      setPaymentMode(resp);
    }
  };

  // const getPaymentModeById = async (id) => {
  //   const resp = await get(`${GET_ALL_PAYMENT_MODE_DATA}/${id}`);
  //   if (resp && resp?.id !== " ") {
  //     setFormValue({
  //       id: resp.id,
  //       paymentMode: resp.paymentMode,
  //     });
  //   }
  // };

  // const statusInactive = async (id) => {
  //   try {
  //     const resp = await Delete(`${EDIT_STATUS_PAYMENT_MODE}/${id}`).then(
  //       (res) => {
  //         getAllPaymentModeMasterData();
  //         return res;
  //       }
  //     );
  //     return resp;
  //   } catch (err) {
  //     return err;
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let resp;
    if (!formValue.id) {
      resp = await axios.post(ADD_PAYMENT_MODE, formValue);
      if (resp?.data?.id === null) {
        return toast.error("Payment Mode Already Exists");
      }
    } else {
      resp = await axios.put(ADD_PAYMENT_MODE, formValue);
      if (!resp?.data?.success) {
        return toast.error(resp.data?.message);
      }
      resp.data = resp.data?.data;
    }
    if (resp?.data?.id) {
      handleClear();
      handleClose();
      getAllPaymentModeMasterData();
      toast.success(
        `Payment Mode ${formValue.id ? "updated" : "added"} Successfully`
      );
    } else {
      toast.error(`Payment Mode ${formValue.id ? "update" : "save"} Failed`);
    }
  };

  /*eslint-disable */
  useEffect(() => {
    getAllPaymentModeMasterData();
  }, []);
  /*eslint-enable */

  return {
    open,
    columns,
    formValue,
    isDisabled,
    paymentModeFilterData,
    handleClose,
    handleSubmit,
    handleClickOpen,
    handleInputChange,
    handleSearchChange,
  };
}
